import { baseApi } from './baseApi';

export function patchAllCachedQueryData({
  dispatch,
  getState,
  endpointName,
  updateDraft,
}) {
  const cachedArgs = baseApi.util.selectCachedArgsForQuery(getState(), endpointName);
  return cachedArgs.map((args) =>
    dispatch(baseApi.util.updateQueryData(endpointName, args, updateDraft))
  );
}

export async function runOptimisticCachedQueryPatches({
  dispatch,
  getState,
  queryFulfilled,
  endpointName,
  updateDraft,
}) {
  const patchResults = patchAllCachedQueryData({
    dispatch,
    getState,
    endpointName,
    updateDraft,
  });

  try {
    await queryFulfilled;
  } catch {
    patchResults.forEach((patchResult) => patchResult.undo());
  }
}
